{
  "result": [
    {
      "workId": "00023",
      "workName": "枇杷山鸟图",
      "museum": "故宫博物馆",
      "mediaType": "绢本",
      "materialType": "设色",
      "styleType": "形制",
      "size": [26.9, 27.2],
      "authorName": "林椿",
      "dynasty": "南宋",
      "class1": "主题",
      "class2": "类型",
      "src": "",
      "tilesPath": ""
    },
    {
      "workId": "00024",
      "workName": "枇杷山鸟图",
      "museum": "故宫博物馆",
      "mediaType": "绢本",
      "materialType": "设色",
      "styleType": "形制",
      "size": [26.9, 27.2],
      "authorName": "林椿",
      "dynasty": "南宋",
      "class1": "主题",
      "class2": "类型",
      "src": "",
      "tilesPath": ""
    },
    {
      "workId": "00028",
      "workName": "枇杷山鸟图",
      "museum": "故宫博物馆",
      "mediaType": "绢本",
      "materialType": "设色",
      "styleType": "形制",
      "size": [26.9, 27.2],
      "authorName": "林椿",
      "dynasty": "南宋",
      "class1": "主题",
      "class2": "类型",
      "src": "",
      "tilesPath": ""
    },
    {
      "workId": "00029",
      "workName": "枇杷山鸟图",
      "museum": "故宫博物馆",
      "mediaType": "绢本",
      "materialType": "设色",
      "styleType": "形制",
      "size": [26.9, 27.2],
      "authorName": "林椿",
      "dynasty": "南宋",
      "class1": "主题",
      "class2": "类型",
      "src": "",
      "tilesPath": ""
    },
    {
      "workId": "00026",
      "workName": "枇杷山鸟图",
      "museum": "故宫博物馆",
      "mediaType": "绢本",
      "materialType": "设色",
      "styleType": "形制",
      "size": [26.9, 27.2],
      "authorName": "林椿",
      "dynasty": "南宋",
      "class1": "主题",
      "class2": "类型",
      "src": "",
      "tilesPath": ""
    },
    {
      "workId": "00027",
      "workName": "枇杷山鸟图",
      "museum": "故宫博物馆",
      "mediaType": "绢本",
      "materialType": "设色",
      "styleType": "形制",
      "size": [26.9, 27.2],
      "authorName": "林椿",
      "dynasty": "南宋",
      "class1": "主题",
      "class2": "类型",
      "src": "",
      "tilesPath": ""
    },
    {
      "workId": "00021",
      "workName": "枇杷山鸟图",
      "museum": "故宫博物馆",
      "mediaType": "绢本",
      "materialType": "设色",
      "styleType": "形制",
      "size": [26.9, 27.2],
      "authorName": "林椿",
      "dynasty": "南宋",
      "class1": "主题",
      "class2": "类型",
      "src": "",
      "tilesPath": ""
    },
    {
      "workId": "00022",
      "workName": "1图",
      "museum": "故宫博物馆",
      "mediaType": "绢本",
      "materialType": "设色",
      "styleType": "形制",
      "size": [26.9, 27.2],
      "authorName": "林椿",
      "dynasty": "南宋",
      "class1": "主题",
      "class2": "类型",
      "src": "",
      "tilesPath": ""
    }
  ]
}
